import { Card, CardContent, CardMedia, Grid } from "@mui/material";
import React, { FC } from "react";
import { Blog } from "../../../interfaces";
import styles from "../../../styles/pages/[blogId].module.scss";
import Link from "next/link";
import { formatDateMY } from "../../../utils/date";

const RelatedPosts: FC<Props> = ({ blogs, blogId }) => {
  const strings = {
    related_posts: "Related Posts",
  };

  return (
    <section className="centerContent">
      <h2 className={styles.relatedPost}>{strings.related_posts}</h2>
      <Grid container spacing={5}>
        {blogs.slice(0, 4)?.map((post: Blog) => {
          if (post.postId === blogId) return;
          return (
            <Grid item xs={12} md={6} key={post.postId} className={styles.post}>
              <Card elevation={0} className={styles.postCard}>
                <CardMedia
                  component="img"
                  height="80"
                  width="80"
                  image={post.postImage}
                  alt={post.postTitle}
                  className={styles.postCardMedia}
                />
                <CardContent className={styles.postCardContent}>
                  <Link href={`/blog/${post.postId}`}>
                    <h4>{post.postTitle}</h4>
                    <p>
                      {formatDateMY(post.postDateTs)}
                    </p>
                  </Link>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </section>
  );
};

interface Props {
  blogs: Blog[];
  blogId: string;
}

export default RelatedPosts;
